<template>
	<v-navigation-drawer
		app
		v-model="parameters.openLeftMenu"
		:mobile-breakpoint="360"
		:mini-variant.sync="parameters.miniLeftMenu"
		:permanent="$mq == 'lg'"
		dark
		:temporary="$mq != 'lg'"
		:color="lx0 && lx0.lx0homolnf ? 'purple darken-4' :  'primary'"
	>
		<v-list-item class="py-2 pl-2">
			<v-list-item-avatar >
				<v-img v-if="lxe && lxe.lxeimagser && lx0 && lx0.lx0logo" :src="`${lxe.lxeimagser}${lx0.lx0logo}`"></v-img>
				<v-img v-else src="../../../public/img/accountDefault.png"></v-img>
			</v-list-item-avatar>

			<v-list-item-title v-if="dc4">{{ dc4.dc4nome }}</v-list-item-title>
		</v-list-item>
		<v-system-bar
			:color="lx0 && lx0.lx0homolnf ? 'purple darken-4' :  'primary'"
			v-if="!parameters.miniLeftMenu"
			class="d-flex justify-center mb-25"
		>
			Empresa: {{this.Company}}
		</v-system-bar>
		<v-divider class="mx-3"></v-divider>

		<v-list dense max-height="40" class="activeClassCustom" nav>
			<v-list-item-group v-model="selected">

				<v-list-item v-if="activateMenu('PDV')" link @click="$router.push('/oryxpdv')">
					<v-list-item-icon class="mr-2 my-2">
						<v-icon size="21" small>mdi-view-dashboard</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title class="caption">Início</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-group
					no-action
					class="activeClassCustom"
					v-if="activateMenu('PD4') || activateMenu('VD1') || activateMenu('CV6') || activateMenu('CX0') || activateMenu('CX1')"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-currency-usd</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Caixa</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item link @click="$router.push('/oryxpdv/caixa')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-home-analytics</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Principal</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('PD4')" :disabled="!enableAction('pd4', 'dc5incluir')" link @click="$router.push('/oryxpdv/venda')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-cart-outline</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Venda</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('VD1')" link @click="$router.push('/oryxpdv/pedidos')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-clipboard-outline</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Pedidos</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('CV6')" link @click="parameters.openProductSearch = true" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-tag</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Consulta Preço</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('CX0') && cx0 == null && lxd && lxd.lxdcaixa" link @click="$router.push('/oryxpdv/abrir-caixa')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-lock-open</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Abrir caixa</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('CX0') && cx0 != null && lxd && lxd.lxdcaixa" link @click="$router.push('/oryxpdv/fechar-caixa')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-lock</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Fechar caixa</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('CX0') && lxd && lxd.lxdcaixa" link @click="$router.push('/oryxpdv/caixas')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-cash-register</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Caixas</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('CX1') && cx0 != null && lxd && lxd.lxdcaixa" link @click="$router.push('/oryxpdv/movimentos-caixa')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-swap-horizontal</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Movimentos</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

				</v-list-group>

				<v-list-group
					no-action
					class="activeClassCustom"
					v-if="activateMenu('CF1')"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-account</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Cliente</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item v-if="activateMenu('CF1')" link @click="$router.push('/oryxpdv/clientes')"  class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-account-multiple</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Clientes</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('CF1')" link @click="$router.push('/oryxpdv/cliente-resumo')"  class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-file-account</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Resumo</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('PDC')" link @click="$router.push('/oryxpdv/integracao-guias')"  class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-account-convert</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Integração Guias</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>

				<v-list-group
					no-action
					class="activeClassCustom"
					v-if="activateMenu('CV5')"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-file-document-multiple-outline</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Fiscal</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item v-if="activateMenu('CV5')" link @click="$router.push('/oryxpdv/tabela-documentos-fiscais')"  class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-file-document-outline</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Documentos Fiscais</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>

				<v-list-item v-if="activateMenu('VDK')" link @click="$router.push('/oryxpdv/devolucoes')">
					<v-list-item-icon class="mr-2 my-2">
						<v-icon size="21" small>mdi-backup-restore</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title class="caption">Devoluções</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-group
					no-action
					class="activeClassCustom"
					v-if="activateMenu('VD1') || activateMenu('VDE')"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-handshake-outline</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="caption">Consignado</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item v-if="activateMenu('VD1')" @click="$router.push('/oryxpdv/pedidos-consignados')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>C</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Consignados em aberto</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('VDE')" @click="$router.push('/oryxpdv/confirmacoes-venda')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>A</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Confirmação</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>

				<v-list-group
					no-action
					class="activeClassCustom"
					v-if="activateMenu('CO1')"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-sack-percent</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="caption">Comissão</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item v-if="activateMenu('CO1')" :disabled="!enableAction('co1', 'dc5incluir')" @click="$router.push('/oryxpdv/fechamento-comissao')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>F</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Fechar</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('CO1')" @click="$router.push('/oryxpdv/fechamentos-comissao')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>F</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Fechamentos</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>

				<v-list-group
					v-if="activateMenu('FNL') && activateMenu('CB1')"
					no-action
					class="activeClassCustom"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-percent</v-icon>

						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Descontos e trocas</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item v-if="activateMenu('FNL')" link @click="$router.push('/oryxpdv/creditos')" class="pl-8">
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-account-cash</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Créditos de cliente</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-group
						sub-group
						v-if="activateMenu('CB1') && lxd && lxd.lxdcash"
						no-action
						class="activeClassCustom"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-ticket-percent</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Cupons</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('CB1')" @click="$router.push('/oryxpdv/cupons-cashbacks')" class="pl-8">
							<v-list-item-icon class="mr-2 my-2">
								<span>C</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Cashback</v-list-item-title>
						</v-list-item>
					</v-list-group>
				</v-list-group>

				<v-list-item link @click="$router.push('/indique-e-ganhe')">
					<v-list-item-icon class="mr-2 my-2">
						<v-icon size="21" small>mdi-circle-multiple</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-badge inline content="Novo" color="green">
							<v-list-item-title class="caption">Indique e ganhe!</v-list-item-title>
						</v-badge>
					</v-list-item-content>
				</v-list-item>

				<v-list-group
					v-if="activateMenu('ET3') && !!lxf.lstLxf && lxf.lstLxf.length > 0"
					no-action
					class="activeClassCustom"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-truck</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Transporte</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item v-if="activateMenu('ET3')" link @click="$router.push('/oryxpdv/etiquetas-de-postagem')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>E</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption" style="white-space: break-spaces !important;">Etiquetas de postagem</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>

				<v-list-group
					no-action
					class="activeClassCustom"
					v-if="activateMenu('ME1') || activateMenu('FN5') || activateMenu('DA1') || activateMenu('MEB') || activateMenu('LOD') || activateMenu('CV5') || activateMenu('FN9')"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-application</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Operações</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('LOD') && lxd && lxd.lxdmodulo == 3 && lxd.lxdloc"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-gas-cylinder</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Locações</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('LOD')" @click="$router.push('/oryxpdv/documentos-de-locacao')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>D</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Documentos de locação</v-list-item-title>
						</v-list-item>
						<v-list-item v-if="activateMenu('LOD')" @click="$router.push('/oryxpdv/locacao-de-cilindros')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>G</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Gerar locações</v-list-item-title>
						</v-list-item>

					</v-list-group>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('ME1')"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-package-variant-closed</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Estoques</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('ME1')" @click="$router.push('/oryxpdv/movimentacoes-fisicas')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>M</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Movimentação física</v-list-item-title>
						</v-list-item>

					</v-list-group>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('FN5') && lxd && lxd.lxdfinanc"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-script-text-outline</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Financeiro</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('FN5')" @click="$router.push('/oryxpdv/movimentacao-de-titulos')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>M</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Movimentação de títulos</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CV5')" @click="$router.push('/oryxpdv/tabela-registro-de-operacoes')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>R</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Registro de operações</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('FN9')" @click="$router.push('/oryxpdv/cheques')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>C</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Cheques</v-list-item-title>
						</v-list-item>
					</v-list-group>
					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="lxd && lxd.lxdmodulo == 3 && activateMenu('MEB')"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-shuffle-variant</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Rastreabilidade</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('MEB') && activateMenu('MEC') && activateMenu('MEE')" link @click="$router.push('/oryxpdv/movimentacao-de-cilindros')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>C</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Movimentação de Cilindros</v-list-item-title>
						</v-list-item>
					</v-list-group>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('DA1')"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-file-document-multiple-outline</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Faturamento</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('DA1')" @click="$router.push('/oryxpdv/agrupamentos-de-documentos')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>A</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Agrupamento de Documentos</v-list-item-title>
						</v-list-item>

					</v-list-group>
					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('VDQ')"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-clipboard-list-outline</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Pedidos</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('VDQ')" @click="$router.push('/oryxpdv/oryxplace-pedidos')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>R</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Registros</v-list-item-title>
						</v-list-item>

					</v-list-group>
				</v-list-group>

				<v-list-group
					no-action
					class="activeClassCustom"
					v-if="lxd && lxd.lxdmodulo == 3 && activateMenu('OF1') || activateMenu('MED') || activateMenu('OFV') || activateMenu('OFY') || activateMenu('OFW')"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-hammer-wrench</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Produção</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item v-if="activateMenu('OF1')" link @click="$router.push('/oryxpdv/ordens-de-producao')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>O</span>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="caption">Ordem de produção</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item v-if="activateSpecialMenu('MED')" link @click="$router.push('/oryxpdv/distribuicoes')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>D</span>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="caption">Distribuição</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item v-if="activateMenu('OFV')" link @click="$router.push('/oryxpdv/tanques-de-materia-prima')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>T</span>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="caption">Tanques</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item v-if="activateMenu('OFY')" link @click="$router.push('/oryxpdv/recepcoes-de-materiais')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>R</span>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="caption">Recepção de materiais</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item v-if="activateMenu('OFW')" @click="$router.push('/oryxpdv/parametros-de-materia-prima')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>M</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâm. de matéria-prima</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>

				<v-list-group
					v-if="!!lxd && !lxd.lxdean && activateMenu('OF3')"
					no-action
					class="activeClassCustom"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-desktop-tower-monitor</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Sistema</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item link @click="$router.push('/oryxpdv/atualizar-dados')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>A</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption" style="white-space: break-spaces !important;">Atualizar dados</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>

				<v-list-group
					no-action
					class="activeClassCustom"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-chart-pie</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Relatórios</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-group
						no-action
						sub-group
						class="activeClassCustom mr-2 my-2 subGroupHeader"
						v-if="activateReportMenu('191') || activateReportMenu('320') || activateReportMenu('324') || activateReportMenu('327') || activateReportMenu('328') || activateReportMenu('329') || activateReportMenu('330') || activateReportMenu('333')"
					>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title class="caption">Vendas</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateReportMenu('191')" link @click="$router.push('/oryxpdv/faturamento-guia-ranking')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('191').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('191') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item v-if="activateReportMenu('320')" link @click="$router.push('/oryxpdv/consignados-abertos')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('320').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('320') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item v-if="activateReportMenu('324')" link @click="$router.push('/oryxpdv/relacao-itens-pedido')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('324').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('324') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item v-if="activateReportMenu('327')" link @click="$router.push('/oryxpdv/faturamento-vendedor-ranking')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('327').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('327') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item v-if="activateReportMenu('328')" link @click="$router.push('/oryxpdv/produtos-vendidos-por-periodo')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('328').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('328') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item v-if="activateReportMenu('329')" link @click="$router.push('/oryxpdv/vendas-por-periodo')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('329').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('329') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item v-if="activateReportMenu('330')" link @click="$router.push('/oryxpdv/ranking-vendas')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('330').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('330') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item v-if="activateReportMenu('333')" link @click="$router.push('/oryxpdv/produtos-vendidos-por-vendedor')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('333').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('333') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>

					<v-list-group
						no-action
						sub-group
						class="activeClassCustom mr-2 my-2 subGroupHeader"
						v-if="activateReportMenu('322')"
					>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title class="caption">Caixa</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateReportMenu('322')" link @click="$router.push('/oryxpdv/demonstrativo-caixa')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('322').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('322') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item v-if="activateReportMenu('345')" link @click="$router.push('/oryxpdv/demonstrativo-movimentacao-caixa')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('345').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('345') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>

					<v-list-group
						no-action
						sub-group
						class="activeClassCustom mr-2 my-2 subGroupHeader"
						v-if="activateReportMenu('112') || activateReportMenu('271')"
					>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title class="caption">Estoque</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateReportMenu('112') && lxd && !lxd.lxdean" link @click="$router.push('/oryxpdv/estoque-produtos')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('112').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('112') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item v-if="activateReportMenu('271') && lxd && lxd.lxdean" link @click="$router.push('/oryxpdv/estoque-ponto-de-venda')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('271').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('271') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>

					<v-list-group
						no-action
						sub-group
						class="activeClassCustom mr-2 my-2 subGroupHeader"
						v-if="activateReportMenu('331') || activateReportMenu('071')"
					>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title class="caption">Produtos</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateReportMenu('331')" link @click="$router.push('/oryxpdv/movimentacao-produtos')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('331').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('331') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item v-if="lxd && !lxd.lxdean && activateReportMenu('071')" link @click="$router.push('/oryxpdv/historico-da-peca')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('071').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('071') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>
					<v-list-group
						no-action
						sub-group
						class="activeClassCustom mr-2 my-2 subGroupHeader"
						v-if="activateReportMenu('331')"
					>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title class="caption">Auditoria</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateReportMenu('331')" link @click="$router.push('/oryxpdv/registros-gerais')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>R</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">Registros gerais</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>

					<v-list-group
						no-action
						sub-group
						class="activeClassCustom mr-2 my-2 subGroupHeader"
						v-if="activateReportMenu('494') && lxd && lxd.lxdmodulo == 3"
					>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title class="caption">Etiquetas</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateReportMenu('494')" link @click="$router.push('/oryxpdv/lote-etiquetas')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('494').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('494') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>
					<v-list-group
						no-action
						sub-group
						class="activeClassCustom mr-2 my-2 subGroupHeader"
						v-if="activateReportMenu('285')"
					>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title class="caption">Financeiro</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateReportMenu('285')" link @click="$router.push('/oryxpdv/liquidacao-movimento-detalhado')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('285').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('285') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>
					<v-list-group
						no-action
						sub-group
						class="activeClassCustom mr-2 my-2 subGroupHeader"
						v-if="activateReportMenu('498') && lxd && lxd.lxdmodulo == 3"
					>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title class="caption">OryxPlace</v-list-item-title>
							</v-list-item-content>
						</template>
						<v-list-item v-if="activateReportMenu('498')" link @click="$router.push('/oryxpdv/mapa-de-distribuicao')" class="pl-4">
							<v-list-item-icon class="mr-2 my-2">
								<span>{{ findRelatName('498').substr(0,1).toUpperCase() }}</span>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption" style="white-space: break-spaces !important;">{{ findRelatName('498') }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>
				</v-list-group>

				<v-list-group
					no-action
					class="activeClassCustom"
					v-if="activateMenu('PD6') || activateMenu('VE0') || activateMenu('VE1') || activateMenu('VE2') || activateMenu('ME9')"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-folder</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Cadastros</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('PD6')"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-finance</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Financeiro</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('PD6')" @click="$router.push('/oryxpdv/parametros-cheque')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>P</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Parâmetros de cheque</v-list-item-title>
						</v-list-item>

					</v-list-group>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('CV1') || activateMenu('CV2')|| activateMenu('CV6') || activateMenu('CVM')"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-adjust</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Operações Comerciais</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('VD4')" @click="$router.push('/oryxpdv/condicoes-pagamento')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>C</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Condições de pagamento</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CV1')" @click="$router.push('/oryxpdv/documentos-fiscais')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>D</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Documentos fiscais</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CV2')" @click="$router.push('/oryxpdv/tipos-titulo')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>T</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Tipos de título</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CV6')" @click="$router.push('/oryxpdv/listas-de-preco')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>L</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Listas de Preço</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CVM')" @click="$router.push('/oryxpdv/grupos-de-operacao')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>G</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Grupos de Operação</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CV3')" @click="$router.push('/oryxpdv/operacoes')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>O</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Operações</v-list-item-title>
						</v-list-item>
						
						<v-list-item v-if="activateMenu('VEA')" @click="$router.push('comissoes')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-sack-percent</v-icon>
							</v-list-item-icon>
							<v-list-item-title class="caption">Comissões</v-list-item-title>
						</v-list-item>

					</v-list-group>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('CF7') || activateMenu('CFE') || activateMenu('CF2') || activateMenu('CFA') || activateMenu('CF4') || activateMenu('CF3') || activateMenu('CFC') || activateMenu('CF8') || activateMenu('CF5') || activateMenu('LXG') || activateMenu('CF6') || activateMenu('CFH')"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-account</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Cliente</v-list-item-title>
							</v-list-item-content>
						</template>
						<v-list-item v-if="activateMenu('LXG')" @click="$router.push('/oryxpdv/agencias-de-postagem')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>A</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Agências de postagem</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CFF') && 1 == 3" @click="$router.push('/oryxpdv/inscricoes')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>I</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Inscrições estaduais</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CVS') && 1 == 3" @click="$router.push('/oryxpdv/bloqueios')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>B</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Bloqueios</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CFE') && 1 == 3" link @click="$router.push('/oryxpdv/contatos')"  class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
									<span>C</span>
							</v-list-item-icon>
								<v-list-item-title class="caption">Contatos</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CF2')" link @click="$router.push('/oryxpdv/codigos-cep')"  class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
									<span>C</span>
							</v-list-item-icon>
								<v-list-item-title class="caption">Códigos CEP</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CFA')" link @click="$router.push('/oryxpdv/dados-pessoais')"  class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
									<span>D</span>
							</v-list-item-icon>
								<v-list-item-title class="caption">Dados Pessoais</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CF4')" link @click="$router.push('/oryxpdv/estados')"  class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
									<span>E</span>
							</v-list-item-icon>
								<v-list-item-title class="caption">Estados</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CFD') && 1 == 3" link @click="$router.push('/oryxpdv/eventos')"  class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
									<span>E</span>
							</v-list-item-icon>
								<v-list-item-title class="caption">Eventos</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CF3')" link @click="$router.push('/oryxpdv/localidades')"  class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
									<span>L</span>
							</v-list-item-icon>
								<v-list-item-title class="caption">Localidades</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CFC') && 1 == 3" link @click="$router.push('/oryxpdv/portadores-preferenciais')"  class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
									<span>P</span>
							</v-list-item-icon>
								<v-list-item-title class="caption">Portadores Preferenciais</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CF8')" @click="$router.push('/oryxpdv/regioes')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>R</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Regiões</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CF6')" @click="$router.push('/oryxpdv/representantes')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>R</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Representantes</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CF5')" link @click="$router.push('/oryxpdv/tipos-de-cliente')"  class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
									<span>T</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Tipos de cliente</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CFB')" @click="$router.push('/oryxpdv/enderecos-de-entrega')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>E</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Endereços de entrega</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CFH')" @click="$router.push('/oryxpdv/grupos-de-endereco-de-entrega')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>G</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Grupos de Endereço de Entrega</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CF0')" @click="$router.push('/oryxpdv/enderecos-cobranca')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>E</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Endereços de cobrança</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CF7')" @click="$router.push('/oryxpdv/transportadores')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>T</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Transportadores</v-list-item-title>
						</v-list-item>
					</v-list-group>
					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('PD6')&& lxd && lxd.lxdmodulo == 3"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-sale</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Preços Especiais</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('PD6')" @click="$router.push('/oryxpdv/precos-especiais-venda')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>V</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Venda</v-list-item-title>
						</v-list-item>
						<v-list-item v-if="activateMenu('PD6')" @click="$router.push('/oryxpdv/precos-especiais-locacao')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>L</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Locação</v-list-item-title>
						</v-list-item>

					</v-list-group>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('VE0') || activateMenu('VE1') || activateMenu('VE2')|| (activateMenu('VE3') && !!fv2 && fv2.fv2previsa) || activateMenu('CVZ') || activateMenu('VE4')"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-cart-outline</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Vendas</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('VE0')" @click="$router.push('/oryxpdv/vendedores')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>V</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Vendedores</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CVZ') && lxd && lxd.lxdmodulo == 0" @click="$router.push('/oryxpdv/precos-especiais-cliente')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>P</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Preços especiais por cliente</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('VE3') && !!fv2 && fv2.fv2previsa" @click="$router.push('/oryxpdv/previsoes-venda')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>P</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Previsão de vendas</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('VE4')" @click="$router.push('/oryxpdv/tipos-de-venda')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>T</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Tipos de venda</v-list-item-title>
						</v-list-item>

						<!-- 	<v-list-item v-if="activateMenu('VE1')" @click="$router.push('/oryxpdv/tipos-de-metas')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>T</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Tipos de metas</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('VE2')" @click="$router.push('/oryxpdv/metas')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>M</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Metas</v-list-item-title>
						</v-list-item> -->

					</v-list-group>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="(activateMenu('CB0') || activateMenu('CB1')) && lxd && lxd.lxdcash"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-cash-refund</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Cashbacks</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('CB0')" @click="$router.push('/oryxpdv/campanhas-cashbacks')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<p>C</p>
							</v-list-item-icon>
							<v-list-item-title class="caption">Campanhas</v-list-item-title>
						</v-list-item>
					</v-list-group>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('PR0') || activateMenu('EAN') || activateMenu('CVN') || activateMenu('CR1') || activateMenu('CO0') || activateMenu('FI0') || activateMenu('PRS') || activateMenu('ET0') || activateMenu('GR0') || activateMenu('PRB')"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-shopping-outline</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Produtos</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('PR0')" @click="$router.push('/oryxpdv/produtos')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>P</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Produto</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('FI0')" @click="$router.push('/oryxpdv/classificacoes-fiscais')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>C</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Classificação fiscal</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('EAN')" @click="$router.push('/oryxpdv/produto-codigos-ean')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>C</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Códigos EAN</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CO0')" @click="$router.push('/oryxpdv/colecoes')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>C</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Coleções</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CR1')" @click="$router.push('/oryxpdv/cores')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>C</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Cores</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('ET0')" @click="$router.push('/oryxpdv/etiquetas')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>E</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Etiquetas</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('IN6')" @click="$router.push('/oryxpdv/fabricantes')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>F</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Fabricantes</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('PRB')" @click="$router.push('/oryxpdv/produto-familias')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>F</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Famílias/Linhas</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('PRS')" @click="$router.push('/oryxpdv/produto-grupos')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>G</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Grupos</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('LX6')" @click="$router.push('/oryxpdv/percentuais')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>P</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Percentuais</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('GR0')" @click="$router.push('/oryxpdv/grades-de-tamanho')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>T</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Tamanhos</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="activateMenu('CVN')" @click="$router.push('/oryxpdv/tributacoes-especificas')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>T</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Tributação específica</v-list-item-title>
						</v-list-item>
					</v-list-group>
					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('DC4')"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-account-group</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Sistema</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('DC4')" @click="$router.push('/oryxpdv/usuarios')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>U</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Usuários</v-list-item-title>
						</v-list-item>

					</v-list-group>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('OFH')"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi mdi-factory</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Produção</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('OFH')" @click="$router.push('/oryxpdv/pecas-nao-conformes')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>N</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Não conformidades</v-list-item-title>
						</v-list-item>

					</v-list-group>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('OFG') || activateMenu('VD0')"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-text-box-search-outline</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Motivos</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('OFH')" @click="$router.push('/oryxpdv/motivos-nao-conformidades')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>N</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Não conformidades</v-list-item-title>
						</v-list-item>

						<v-list-item
							v-if="activateMenu('VD0')"
							@click="$router.push('/oryxpdv/motivos')"
							class="pl-16"
						>
							<v-list-item-icon class="mr-2 my-2">
								<span>R</span>
							</v-list-item-icon>

							<v-list-item-title class="caption">
								Motivos de rejeição
							</v-list-item-title>
						</v-list-item>

					</v-list-group>

					<v-list-group
						no-action
						class="activeClassCustom"
						sub-group
						v-if="activateMenu('ME9') && lxd && lxd.lxdmodulo == 3"
					>
						<template v-slot:activator>
							<v-list-item-icon class="mr-2 my-2">
								<v-icon size="21" small>mdi-gas-cylinder</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="caption">Materiais</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="activateMenu('ME9')" @click="$router.push('/oryxpdv/cadastro-de-recipientes')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>R</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Recipientes</v-list-item-title>
						</v-list-item>
						<v-list-item v-if="activateMenu('INC')" @click="$router.push('/oryxpdv/subclasses')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>S</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Sub Classes</v-list-item-title>
						</v-list-item>
						<v-list-item v-if="activateMenu('FM1')" @click="$router.push('/oryxpdv/campos-analises')" class="pl-16">
							<v-list-item-icon class="mr-2 my-2">
								<span>C</span>
							</v-list-item-icon>
							<v-list-item-title class="caption">Campos de análise</v-list-item-title>
						</v-list-item>

					</v-list-group>
				</v-list-group>

				<v-list-item v-if="lx0 && lx0.lx0csc && lx0.lx0csc != '00000000-0000-0000-0000-000000000000' && lx0.cf3estado == 'SC'" link @click="parameters.openDialogFiscalPaf = true">
					<v-list-item-icon class="mr-2 my-2">
						<v-icon size="21" small>mdi-receipt</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title class="caption">Menu Fiscal</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-group
					no-action
					class="activeClassCustom"
					v-if="activateMenu('LXD') || activateMenu('PD0') || activateMenu('PD1') ||activateMenu('PD2') || activateMenu('PD5') || activateMenu('LXE') || activateMenu('PD8') || activateMenu('WHA') || activateMenu('LXF') || activateMenu('LXH') || activateMenu('LXR')"
				>
					<template v-slot:activator>
						<v-list-item-icon class="mr-2 my-2">
							<v-icon size="21" small>mdi-cog</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="caption">Configurações</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item v-if="activateMenu('LXD')" @click="$router.push('/oryxpdv/parametros')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâmetros</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('EST')" @click="$router.push('/oryxpdv/estabelecimentos')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>E</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Estabelecimentos</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('PD3')" @click="$router.push('/oryxpdv/parametros-principais-caixa')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâmetros - Tela Caixa</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('LXH') && lxd && lxd.lxdtef" @click="$router.push('/oryxpdv/integracao-tef')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>I</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Integração TEF</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('LXR')" @click="$router.push('/oryxpdv/parametros-rastreio')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâmetro Rastreio</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('PD0')" @click="$router.push('/oryxpdv/terminais')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>T</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Terminais</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('PD1')" @click="$router.push('/oryxpdv/preferencias-de-impressao')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Preferências de impressão</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('PD2')" @click="$router.push('/oryxpdv/parametros-operacoes-venda')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâmetros operacionais</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('PD5')" @click="$router.push('/oryxpdv/parametros-shopping')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâmetros shopping</v-list-item-title>
						</v-list-item-content>
					</v-list-item>


					<v-list-item v-if="activateMenu('LXE')" @click="$router.push('/oryxpdv/parametros-api')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâmetros de API</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item v-if="activateMenu('PD8')" @click="$router.push('/oryxpdv/parametros-integracao-guia')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâm. Integração Guias</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item v-if="activateMenu('WHA')" @click="$router.push('/oryxpdv/parametros-oryx-whatsapp')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâm. Oryx WhatsApp</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item v-if="activateMenu('LXF')" @click="$router.push('/oryxpdv/integracoes-logisticas')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>I</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Integrações logísticas</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('LXK')" @click="$router.push('/oryxpdv/parametros-insumo')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâmetros de OF</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('ATT')" @click="$router.push('/oryxpdv/configuracao-atualizacao')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>C</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Configurações de Atualização</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="activateMenu('LXA') && lxd && lxd.lxdfinanc" @click="$router.push('/oryxpdv/parametros-financeiros')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâmetros financeiros</v-list-item-title>
						</v-list-item-content>
					</v-list-item>


					<v-list-item v-if="activateMenu('LXL')" @click="$router.push('/oryxpdv/parametros-de-usuario')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâmetros de usuário</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="lxd && lxd.lxdmodulo == 3 && activateMenu('LXJ')" @click="$router.push('/oryxpdv/parametros-oryxplace')" class="pl-4">
						<v-list-item-icon class="mr-2 my-2">
							<span>P</span>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title class="caption">Parâmetros Oryxplace</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>

				<v-list-item link @click="logoff">
					<v-list-item-icon class="mr-2 my-2">
						<v-icon size="21" small>mdi-logout</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title class="caption">Sair</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list-item-group>
		</v-list>
		<template v-slot:append>
			<div v-if="!parameters.miniLeftMenu">
				<div v-if="showAtualizationAlert" class="yellow--text text-center py-1 caption font-weight-bold">
					*Atualização disponível
				</div>
				<div class="overline white--text d-flex justify-center font-weight-bold">{{ appVersion }}</div>
			</div>
		</template>
	</v-navigation-drawer>
</template>

<script>
import formMixin from "@/plugins/mixins/formMixin"
import { version } from '../../../package'

export default {
	data: () => ({
		selected: null,
		appVersion: version,
		Company: null
	}),
	mixins: [formMixin],
	created() {
		this.Company = localStorage.getItem('company') || '';
	},
	computed: {
		parameters: {
			get() {
				return this.$store.state.parameters;
			},
		},
		dc4: {
			get() {
				return this.$store.state.dc4.dc4;
			},
		},
		lxe: {
			get() {
				return this.$store.state.lxe.lxe;
			},
		},
		lx0: {
			get() {
				return this.$store.state.lx0.lx0;
			},
		},
		lxd: {
			get() {
				return this.$store.state.lxd.lxd;
			},
		},
		cx0: {
			get() {
				return this.$store.state.cx0.cx0;
			},
		},
		lxf: {
			get() {
				return this.$store.state.lxf;
			},
		},
		fv2: {
			get() {
				return this.$store.state.fv2.fv2;
			},
		},
		att: {
			get() {
				return this.$store.state.att.att;
			},
		},
		attmodel: {
			get() {
				return this.$store.state.att.att;
			},
		},	

		showAtualizationAlert() {
			return this.attmodel && 
                   this.attmodel.atttematt && this.attmodel.attagend &&
                   !this.attmodel.attautoriz
		}
	},
	methods:{
		activateMenu(dc0arquivo){
			return this.dc4 &&
					this.dc4.lstDc5 &&
					this.dc4.lstDc5.filter(dc5 => dc5.dc5arquivo.toUpperCase() == dc0arquivo.toUpperCase())[0]
		},
		activateSpecialMenu(dc0arquivo){
			return this.dc4 &&
					this.dc4.lstDc5 &&
					this.dc4.lstDc5.filter(dc5 => dc5.dc5arquivo.toUpperCase() == dc0arquivo.toUpperCase() &&
					dc5.dc5especia == 1)[0]
		},

		activateReportMenu(dc9relat) {
			if (!this.dc4 || !this.dc4.lstDc9 || !this.dc4.lstDc5)
				return null

			const relat = this.dc4.lstDc9.find(dc9 =>
				dc9?.dc9relat?.toUpperCase() === dc9relat?.toUpperCase()
			)

			if (!relat || !relat.dc9arquivo)
				return null
			
			return this.dc4.lstDc5.find(dc5 =>
				dc5.dc5arquivo.toUpperCase() === relat.dc9arquivo.toUpperCase()
			) || null
		},

		findRelatName(dc9relat){
			if( this.dc4 &&
				this.dc4.lstDc9 &&
				this.dc4.lstDc9.filter(dc9 => dc9.dc9relat.toUpperCase() == dc9relat.toUpperCase())[0]
			){
				return this.dc4.lstDc9.filter(dc9 => dc9.dc9relat.toUpperCase() == dc9relat.toUpperCase())[0].dc9nome
			}
			return ""
		},
		
		logoff(){
			this.$store.dispatch("dc4/logoff")
		},
		openMenu(route){
			this.$router.push(route)
		},
		openGroup(prsgrupo){
			this.$store.dispatch("product/clearFilteredFields")
			this.$router.push({path: "/pesquisa", query:{ groups: [prsgrupo] }})
		},
		openCollection(co0colecao){
			this.$store.dispatch("product/clearFilteredFields")
			this.$router.push({path: "/pesquisa", query:{ collections: [co0colecao] }})
		},
		openNewCustomer(){
			this.$router.push({path: "/confirmacaoclientes"})
		},
		openProducts(){
			this.$router.push({path: "/manterprodutos"})
		},
		openB2D(){
			this.$router.push({path: "/textos"})
		},
	},
};
</script>

<style scoped>
.activeClassCustom >>> .v-list-item--active{
	color: #b39246 !important;
	background-color: transparent !important;
}

.subGroupHeader >>> .v-list-group__header{
	padding-left: 8px !important;
}
.mb-25 {
    margin-bottom: 15px !important;
}
</style>
